import {HOME, ROLE_MANAGEMENT, USER_MANAGEMENT} from "./path";

export const LINKS = {
  CMS: [
    {
      path: HOME,
      name: "Home",
    },
    {
      path: USER_MANAGEMENT,
      name: "User Management",

    },
    {
      path: ROLE_MANAGEMENT,
      name: "Role Management",
    },
  ],
  UserSite: [
    {
      path: HOME,
      name: "Home",
    },
  ]
}
